import useGetPaymentFile from 'hooks/useGetPaymentFile';
import useToastContext from 'hooks/useToastContext';
import { Settlement } from 'interfaces/balances';
import React, { useState } from 'react';
import SettlementPaymentFileDownloadButton from './SettlementPaymentFileDownloadButton';
import SettlementPaymentFileUploadButton from './SettlementPaymentFileUploadButton';
import {Col, Row,} from 'antd';

const selectButton = (settlement: Settlement, payment: string|undefined, setPayment: (string)=>void, paymentType: string, onDownloadClick: ()=>void )=> {
	if (payment === undefined) {
		return <SettlementPaymentFileUploadButton settlement={settlement} paymentType={paymentType} setPayment={setPayment}/>
	} else {
		return <Row gutter={10}>
			<Col span={4}>
				<SettlementPaymentFileUploadButton settlement={settlement} paymentType={paymentType} setPayment={setPayment}/>
			</Col>
			<Col span={1}/>
			<Col span={4}>
				<SettlementPaymentFileDownloadButton onClick={ onDownloadClick }/>
			</Col>
		</Row>
	}
}

const SettlementPaymentFileButton = ({settlement, paymentFile, paymentType}: {settlement: Settlement, paymentFile: string|undefined, paymentType: string})=> {
	const toast = useToastContext();
	const [payment, setPayment] = useState(paymentFile);
	const { fileLoading, execute } = useGetPaymentFile(payment)

	const downloadPayment = async () => {
		const response = await execute();
		if(response?.status === 200 || response?.status === 204) {
			window.open(response?.data?.url);
			toast.success("Exito", "Archivo descargado");
		}
	}

	return(selectButton(settlement, payment, setPayment, paymentType, downloadPayment))
}

export default SettlementPaymentFileButton;
